import { render, staticRenderFns } from "./LiquidationQuery.vue?vue&type=template&id=60dff3a0"
import script from "./LiquidationQuery.vue?vue&type=script&lang=js"
export * from "./LiquidationQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports